import React from "react";
import {
  IconFlatFee,
  IconKeepWhatYouRaise,
  IconKeepUsHonest,
} from "../Icon";

const InformationCard = ({ paymentModel, title, information }) => (
  <div className="fees__donation-form-type">
    <div className="full-width">
      { paymentModel === "Keep 100" && <IconKeepWhatYouRaise /> }
      { paymentModel === "Shared" && <IconKeepUsHonest /> }
      { paymentModel === "Flat Fee" && <IconFlatFee /> }
    </div>
    <h3 className="fees__donation-form-type-title">{ title }</h3>
    <div dangerouslySetInnerHTML={{ __html: information }} />
  </div>
);

export default InformationCard;
